<template>
  <b-row style="margin-top: 1em">
    <b-col>
      <h5 v-if="settings.length > 0" class="text-info">
        {{ $t("globals.settings") }}:
      </h5>
      <b-table bordered small :items="settings"> </b-table>
    </b-col>
    <b-col> </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    settings: Array
  }
};
</script>
